import React from 'react';

const LEVELS = ['TRADITIONAL', 'INITIAL', 'ADVANCED', 'OPTIMAL'];
const LEVEL_LABELS = {
  TRADITIONAL: 'Trad',
  INITIAL: 'Init',
  ADVANCED: 'Adv',
  OPTIMAL: 'Opt'
};
const LEVEL_COLORS = {
  TRADITIONAL: '#6b7280',
  INITIAL: '#eab308',
  ADVANCED: '#3b82f6',
  OPTIMAL: '#10b981'
};

/**
 * CisaGapBar - Visual progress bar showing current → target maturity gap
 *
 * Props:
 *   currentLevel - 'TRADITIONAL' | 'INITIAL' | 'ADVANCED' | 'OPTIMAL'
 *   targetLevel - 'TRADITIONAL' | 'INITIAL' | 'ADVANCED' | 'OPTIMAL'
 *   compact - boolean (for collapsed card view)
 *   showLabels - boolean (show level labels below segments)
 */
const CisaGapBar = ({ currentLevel = 'TRADITIONAL', targetLevel, compact = false, showLabels = false }) => {
  const currentIndex = LEVELS.indexOf(currentLevel);
  const targetIndex = targetLevel ? LEVELS.indexOf(targetLevel) : currentIndex;
  const hasGap = targetIndex > currentIndex;

  return (
    <div className={`cisa-gap-bar ${compact ? 'cisa-gap-bar--compact' : ''}`}>
      <div className="cisa-gap-bar-track">
        {LEVELS.map((level, idx) => {
          // Determine segment state
          const isFilled = idx <= currentIndex;
          const isGap = idx > currentIndex && idx <= targetIndex;
          const segmentColor = LEVEL_COLORS[level];

          return (
            <div
              key={level}
              className={`cisa-gap-segment ${isFilled ? 'cisa-gap-segment--filled' : ''} ${isGap ? 'cisa-gap-segment--gap' : ''}`}
              style={{
                '--segment-color': segmentColor,
                '--segment-fill': isFilled ? segmentColor : isGap ? `${segmentColor}40` : 'transparent'
              }}
              title={`${LEVEL_LABELS[level]}: ${isFilled ? 'Current' : isGap ? 'Target' : 'Not reached'}`}
            >
              {/* Hatched pattern for gap segments */}
              {isGap && <div className="cisa-gap-segment-hatch" />}
            </div>
          );
        })}
      </div>

      {showLabels && (
        <div className="cisa-gap-bar-labels">
          {LEVELS.map((level, idx) => (
            <span
              key={level}
              className={`cisa-gap-bar-label ${idx <= currentIndex ? 'cisa-gap-bar-label--active' : ''}`}
            >
              {LEVEL_LABELS[level]}
            </span>
          ))}
        </div>
      )}

      {/* Compact: show gap text inline */}
      {compact && hasGap && (
        <span className="cisa-gap-bar-gap-text">
          {LEVEL_LABELS[currentLevel]} → {LEVEL_LABELS[targetLevel]}
        </span>
      )}
    </div>
  );
};

export default CisaGapBar;
